//ADAPTED FROM https://github.com/shrekshao/minimal-gltf-loader

import {vec3, vec4, quat, mat4} from '../../beam/index';
import FileLoader from './THREE.FileLoader' 
import DracoLoader from './THREE.DracoLoader'


var dracoLoaderInstance = new DracoLoader();
dracoLoaderInstance.setDecoderPath('assets/js/');//https://www.gstatic.com/draco/versioned/decoders/1.4.1/
dracoLoaderInstance.preload();


var WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
var ATTRIBUTES = {
    POSITION:   'POSITION',
    NORMAL:     'NORMAL',
    TANGENT:    'tangent',
    TEXCOORD_0: 'TEXCOORD_0',
    TEXCOORD_1: 'TEXCOORD_1',
    COLOR_0:    'COLOR_0',
    WEIGHTS_0:  'WEIGHTS_0',
    JOINTS_0:   'JOINTS_0',
};

var MinimalGLTFLoader = MinimalGLTFLoader || {};
var curLoader = null;       // @tmp, might be unsafe if loading multiple model at the same time

class Scene {
    constructor(gltf, s) {
        this.name = s.name !== undefined ? s.name : null;
        this.nodes = new Array(s.nodes.length);    // root node object of this scene
        for (var i = 0, len = s.nodes.length; i < len; i++) {
            this.nodes[i] = gltf.nodes[s.nodes[i]];
        }
        this.extensions = s.extensions !== undefined ? s.extensions : null;
        this.extras = s.extras !== undefined ? s.extras : null;
        this.boundingBox = null;
    }
}


var BoundingBox = MinimalGLTFLoader.BoundingBox = function (min, max, isClone) {
    min = min || vec3.fromValues(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY);
    max = max || vec3.fromValues(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
    if (isClone === undefined || isClone === true) {
        this.min = vec3.clone(min);
        this.max = vec3.clone(max);
    } else {
        this.min = min;
        this.max = max;
    }
    this.transform = mat4.create();
};
BoundingBox.prototype.updateBoundingBox = function (bbox) {
    vec3.min(this.min, this.min, bbox.min);
    vec3.max(this.max, this.max, bbox.max);
};
BoundingBox.prototype.calculateTransform = function () {
    // transform from a unit cube whose min = (0, 0, 0) and max = (1, 1, 1)
    // scale
    this.transform[0] = this.max[0] - this.min[0];
    this.transform[5] = this.max[1] - this.min[1];
    this.transform[10] = this.max[2] - this.min[2];
    // translate
    this.transform[12] = this.min[0];
    this.transform[13] = this.min[1];
    this.transform[14] = this.min[2];
};
BoundingBox.getAABBFromOBB = (function() {
    var transformRight = vec3.create();
    var transformUp = vec3.create();
    var transformBackward = vec3.create();
    var tmpVec3a = vec3.create();
    var tmpVec3b = vec3.create();
    return (function (obb, matrix) {
        vec3.set(transformRight, matrix[0], matrix[1], matrix[2]);
        vec3.set(transformUp, matrix[4], matrix[5], matrix[6]);
        vec3.set(transformBackward, matrix[8], matrix[9], matrix[10]);
        var min = vec3.fromValues(matrix[12], matrix[13], matrix[14]);  // init with matrix translation
        var max = vec3.clone(min);
        vec3.scale(tmpVec3a, transformRight, obb.min[0]);
        vec3.scale(tmpVec3b, transformRight, obb.max[0]);
        vec3.min(transformRight, tmpVec3a, tmpVec3b);
        vec3.add(min, min, transformRight);
        vec3.max(transformRight, tmpVec3a, tmpVec3b);
        vec3.add(max, max, transformRight);
        vec3.scale(tmpVec3a, transformUp, obb.min[1]);
        vec3.scale(tmpVec3b, transformUp, obb.max[1]);
        vec3.min(transformUp, tmpVec3a, tmpVec3b);
        vec3.add(min, min, transformUp);
        vec3.max(transformUp, tmpVec3a, tmpVec3b);
        vec3.add(max, max, transformUp);
        vec3.scale(tmpVec3a, transformBackward, obb.min[2]);
        vec3.scale(tmpVec3b, transformBackward, obb.max[2]);
        vec3.min(transformBackward, tmpVec3a, tmpVec3b);
        vec3.add(min, min, transformBackward);
        vec3.max(transformBackward, tmpVec3a, tmpVec3b);
        vec3.add(max, max, transformBackward);
        var bbox = new BoundingBox(min, max, false);
        bbox.calculateTransform();
        return bbox;
    });
})();



class Accessor {
    constructor(a, bufferViewObject) {
        this.bufferView    = bufferViewObject;  // required
        this.componentType = a.componentType;   // required
        this.byteOffset    = a.byteOffset !== undefined ? a.byteOffset : 0;
        this.byteStride    = bufferViewObject.byteStride;
        this.normalized    = a.normalized !== undefined ? a.normalized : false;
        this.count         = a.count;   // required
        this.type          = a.type;     // required
        this.size          = Type2NumOfComponent[this.type];
        this.min           = a.min;   // @tmp assume required for now (for bbox)
        this.max           = a.max;   // @tmp assume required for now (for bbox)
        this.extensions    = a.extensions !== undefined ? a.extensions : null;
        this.extras        = a.extras !== undefined ? a.extras : null;
    }
}


class BufferView {
    constructor(bf, bufferData) {
        this.byteLength = bf.byteLength; 
        this.byteOffset = bf.byteOffset !== undefined ? bf.byteOffset : 0;
        this.byteStride = bf.byteStride !== undefined ? bf.byteStride : 0;
        this.target = bf.target !== undefined ? bf.target : null;
        this.data = bufferData.slice(this.byteOffset, this.byteOffset + this.byteLength);
        this.extensions = bf.extensions !== undefined ? bf.extensions : null;
        this.extras = bf.extras !== undefined ? bf.extras : null;
        this.buffer = null;
    }
}



var TRSMatrix = mat4.create();
var Node = function (n, nodeID) {
    this.name = n.name !== undefined ? n.name : null;
    this.nodeID = nodeID;
    this.camera = n.camera !== undefined ? n.camera : null;
    this.matrix = mat4.create();
    if (n.hasOwnProperty('matrix')) {
        for(var i = 0; i < 16; ++i) {
            this.matrix[i] = n.matrix[i];
        }
        this.translation = vec3.create();
        mat4.getTranslation(this.translation, this.matrix);
        this.rotation = quat.create();
        mat4.getRotation(this.rotation, this.matrix);
        this.scale = vec3.create();
        mat4.getScaling(this.scale, this.matrix);
    } else {
        this.getTransformMatrixFromTRS(n.translation, n.rotation, n.scale);
    }
    this.children = n.children || [];  // init as id, then hook up to node object later
    this.mesh = n.mesh !== undefined ? curLoader.glTF.meshes[n.mesh] : null;

    this._savedMeshIndex = n.mesh;// !== undefined ? curLoader.glTF.meshes[n.mesh] : null;

    
    this.skin = n.skin !== undefined ? n.skin : null;   // init as id, then hook up to skin object later
    // TODO: morph targets weights
    this.weights = n.weights !== undefined ? n.weights : null;
    this.extensions = n.extensions !== undefined ? n.extensions : null;
    this.extras = n.extras !== undefined ? n.extras : null;
    this.aabb = null;   // axis aligned bounding box, not need to apply node transform to aabb
    this.bvh = new BoundingBox();
}
Node.prototype.traverse = function(parent, executeFunc) {
    executeFunc(this, parent);
    for (var i = 0, len = this.children.length; i < len; i++) {
        this.children[i].traverse(this, executeFunc);
    }
}
Node.prototype.traversePostOrder = function(parent, executeFunc) {
    for (var i = 0, len = this.children.length; i < len; i++) {
        this.children[i].traversePostOrder(this, executeFunc);
    }
    executeFunc(this, parent);
};

Node.prototype.traverseTwoExecFun = function(parent, execFunPre, execFunPos) {
    execFunPre(this, parent);
    for (var i = 0, len = this.children.length; i < len; i++) {
        this.children[i].traverseTwoExecFun(this, execFunPre, execFunPos);
    }
    execFunPos(this, parent);
};
Node.prototype.getTransformMatrixFromTRS = function(translation, rotation, scale) {
    this.translation = translation !== undefined ? vec3.fromValues(translation[0], translation[1], translation[2]) : vec3.fromValues(0, 0, 0);
    this.rotation = rotation !== undefined ? vec4.fromValues(rotation[0], rotation[1], rotation[2], rotation[3]) : vec4.fromValues(0, 0, 0, 1);
    this.scale = scale !== undefined ? vec3.fromValues(scale[0], scale[1], scale[2]) : vec3.fromValues(1, 1, 1);
    this.updateMatrixFromTRS();
};
Node.prototype.updateMatrixFromTRS = function() {
    mat4.fromRotationTranslation(TRSMatrix, this.rotation, this.translation);
    mat4.scale(this.matrix, TRSMatrix, this.scale);
};







class Mesh {
    constructor(m, meshID) {
        this.meshID = meshID;
        this.name = m.name !== undefined ? m.name : null;
        this.primitives = [];   // required
        this.boundingBox = null;
        var p, primitive, accessor;
        for (var i = 0, len = m.primitives.length; i < len; ++i) {
            p = m.primitives[i];
            primitive = new Primitive(curLoader.glTF, p);
            this.primitives.push(primitive);
            if (primitive.boundingBox) {
                if (!this.boundingBox) {
                    this.boundingBox = new BoundingBox();
                }
                this.boundingBox.updateBoundingBox(primitive.boundingBox);
            }
        }
        if (this.boundingBox) {
            this.boundingBox.calculateTransform();
        }
        this.weights = m.weights !== undefined ? m.weights : null;
        this.extensions = m.extensions !== undefined ? m.extensions : null;
        this.extras = m.extras !== undefined ? m.extras : null;
    }
}





var Primitive = function (gltf, p) {
    // <attribute name, accessor id>, required
    // get hook up with accessor object in _postprocessing
    this.attributes = p.attributes;
    this.indices = p.indices !== undefined ? p.indices : null;  // accessor id

    var attname;
    if (p.extensions !== undefined) {
        if (p.extensions.gl_avatar !== undefined && curLoader.enableGLAvatar === true) {
            if (p.extensions.gl_avatar.attributes) {
                for ( attname in p.extensions.gl_avatar.attributes ) {
                    this.attributes[attname] = p.extensions.gl_avatar.attributes[attname];
                }
            }
        }
    }

    this.material = p.material !== undefined && gltf && gltf.materials ? gltf.materials[p.material] : null;
    this.mode = p.mode !== undefined ? p.mode : 4; // default: gl.TRIANGLES
    this.targets = p.targets;
    this.extensions = p.extensions !== undefined ? p.extensions : null;
    this.extras = p.extras !== undefined ? p.extras : null;
    this.vertexArray = null;   
    this.vertexBuffer = null;
    this.indexBuffer = null;
    this.shader = null;
    this.boundingBox = null;

    if (p.extensions && p.extensions.KHR_draco_mesh_compression) {
        //
    }
    else {
        if (this.indices !== null) {
            this.indicesComponentType = gltf.json.accessors[this.indices].componentType;
            this.indicesLength = gltf.json.accessors[this.indices].count;
            this.indicesOffset = (gltf.json.accessors[this.indices].byteOffset || 0);
        } else {
            // assume 'POSITION' is there
            this.drawArraysCount = gltf.json.accessors[this.attributes.POSITION].count;
            this.drawArraysOffset = (gltf.json.accessors[this.attributes.POSITION].byteOffset || 0);
        }
        // hook up accessor object
        for ( attname in this.attributes ) {
            this.attributes[attname] = gltf.accessors[ this.attributes[attname] ];
        }
        if (this.attributes.POSITION !== undefined) {
            let accessor = this.attributes.POSITION;
            if (accessor.min && accessor.max && accessor.type === 'VEC3') {
                this.boundingBox = new BoundingBox(
                    vec3.fromValues(accessor.min[0], accessor.min[1], accessor.min[2]),
                    vec3.fromValues(accessor.max[0], accessor.max[1], accessor.max[2]),
                    false
                );
            }
        }
        if (this.indices !== null) {
            this.indices = _getAccessorData( gltf.accessors[ this.indices ] );
        }
        for (let attr in this.attributes) {
            this.attributes[attr] = _getAccessorData( this.attributes[attr] )
        }
    }

}


var TextureInfo = function (json) {
    this.index = json.index;
    this.texCoord = json.texCoord !== undefined ? json.texCoord : 0 ;
    this.extensions = json.extensions !== undefined ? json.extensions : null;
    this.extras = json.extras !== undefined ? json.extras : null;
};

var PbrMetallicRoughness = function (json) {
    this.baseColorFactor = json.baseColorFactor !== undefined ? json.baseColorFactor : [1, 1, 1, 1];
    this.baseColorTexture = json.baseColorTexture !== undefined ? new TextureInfo(json.baseColorTexture): null;
    this.metallicFactor = json.metallicFactor !== undefined ? json.metallicFactor : 1 ;
    this.roughnessFactor = json.roughnessFactor !== undefined ? json.roughnessFactor : 1 ;
    this.metallicRoughnessTexture = json.metallicRoughnessTexture !== undefined ? new TextureInfo(json.metallicRoughnessTexture): null;
    this.extensions = json.extensions !== undefined ? json.extensions : null;
    this.extras = json.extras !== undefined ? json.extras : null;
};

var NormalTextureInfo = function (json) {
    this.index = json.index;
    this.texCoord = json.texCoord !== undefined ? json.texCoord : 0 ;
    this.scale = json.scale !== undefined ? json.scale : 1 ;
    this.extensions = json.extensions !== undefined ? json.extensions : null;
    this.extras = json.extras !== undefined ? json.extras : null;
};

var OcclusionTextureInfo = function (json) {
    this.index = json.index;
    this.texCoord = json.texCoord !== undefined ? json.texCoord : 0 ;
    this.strength = json.strength !== undefined ? json.strength : 1 ;
    this.extensions = json.extensions !== undefined ? json.extensions : null;
    this.extras = json.extras !== undefined ? json.extras : null;
};

var Material = function (m) {
    this.name = m.name !== undefined ? m.name : null;
    this.pbrMetallicRoughness = m.pbrMetallicRoughness !== undefined ? new PbrMetallicRoughness( m.pbrMetallicRoughness ) : new PbrMetallicRoughness({
        baseColorFactor: [1, 1, 1, 1],
        metallicFactor: 1,
        metallicRoughnessTexture: 1
    });
    this.normalTexture = m.normalTexture !== undefined ? new NormalTextureInfo(m.normalTexture) : null;
    this.occlusionTexture = m.occlusionTexture !== undefined ? new OcclusionTextureInfo(m.occlusionTexture) : null;
    this.emissiveTexture = m.emissiveTexture !== undefined ? new TextureInfo(m.emissiveTexture) : null;
    this.emissiveFactor = m.emissiveFactor !== undefined ? m.emissiveFactor : [0, 0, 0];
    this.alphaMode = m.alphaMode !== undefined ? m.alphaMode : "OPAQUE";
    this.alphaCutoff = m.alphaCutoff !== undefined ? m.alphaCutoff : 0.5;
    this.doubleSided = m.doubleSided || false;
    this.extensions = m.extensions !== undefined ? m.extensions : null;
    this.extras = m.extras !== undefined ? m.extras : null;
};


var glTFModel = MinimalGLTFLoader.glTFModel = function (gltf) {
    this.json = gltf;
    this.defaultScene = gltf.scene !== undefined ? gltf.scene : 0;
    this.version = Number(gltf.asset.version);
    if (gltf.accessors) {
        this.accessors = new Array(gltf.accessors.length);
    }
    if (gltf.bufferViews) {
        this.bufferViews = new Array(gltf.bufferViews.length);
    }
    if (gltf.scenes) {
        this.scenes = new Array(gltf.scenes.length);   // store Scene object
    }
    if (gltf.nodes) {
        this.nodes = new Array(gltf.nodes.length);    // store Node object
    }
    if (gltf.meshes) {
        this.meshes = new Array(gltf.meshes.length);    // store mesh object
    }
    if (gltf.materials) {
        this.materials = new Array(gltf.materials.length);  // store material object
    }
    this.extensions = gltf.extensions !== undefined ? gltf.extensions : null;
    this.extras = gltf.extras !== undefined ? gltf.extras : null;
};



var gl;
var glTFLoader = MinimalGLTFLoader.glTFLoader = function (glContext) {
    gl = glContext !== undefined ? glContext : null;

    curLoader = null;
    this._init();
    this.glTF = null;
    this.enableGLAvatar = false;
    this.linkSkeletonGltf = null;
};

glTFLoader.prototype._init = function() {
    this._loadDone = false;
    this._bufferRequested = 0;
    this._bufferLoaded = 0;
    this._buffers = [];
    this._bufferTasks = {};
    this._shaderRequested = 0;
    this._shaderLoaded = 0;
    this._imageRequested = 0;
    this._imageLoaded = 0;
    this._pendingTasks = 0;
    this._finishedPendingTasks = 0;
    this.onload = null;
};

glTFLoader.prototype._checkComplete = function () {
    if (this._bufferRequested == this._bufferLoaded && 
        this._imageRequested == this._imageLoaded 
        ) {
        this._loadDone = true;
    }
    if (this._loadDone && this._pendingTasks == this._finishedPendingTasks) {
        this._postprocess(()=>{
            this.onload(this.glTF);
        });
    }
};

glTFLoader.prototype.loadGLTF_GL_Avatar_Skin = function (uri, skeletonGltf, callback) {
    this.enableGLAvatar = true;
    this.skeletonGltf = skeletonGltf;

    this.loadGLTF(uri, callback);
};

/**
 * load a glTF model
 * 
 * @param {String} uri uri of the .glTF file. Other resources (bins, images) are assumed to be in the same base path
 * @param {Function} callback the onload callback function
 */
glTFLoader.prototype.loadGLTF = function (uri, callback) {

    this._init();
    this.onload  = callback || function() {};
    this.baseUri = _getBaseUri(uri);
    var self   = this;

    _loadJSON(uri, function (response) {

        // Parse JSON string into object
        var json = JSON.parse(response);
        
        self.glTF = new glTFModel(json);

        let useDraco = false
        if (json.extensionsRequired) {
            for (let ii=0; ii<json.extensionsRequired.length; ii++) {
                if (json.extensionsRequired[ii] == "KHR_draco_mesh_compression") {
                    useDraco = true;
                }
            }
        }

        if (useDraco) {
            self.useDraco = true;
            self.dracoLoader = dracoLoaderInstance//
            
        }


        // Launch loading resources task: buffers, etc.
        if (json.buffers) 
        {
            for (let bid in json.buffers) 
            {
                
                if (self.useDraco) 
                {
                    self._bufferRequested++;
                    var _loader = new FileLoader( self.dracoLoader.manager );
                    _loader.setResponseType( 'arraybuffer' );
                    _loader.setWithCredentials( true );
                    _loader.load( json.buffers[bid].uri, ( buffer ) => {
                        self._buffers[bid] = buffer;
                        self._bufferLoaded++;
                        self._checkComplete();
                    });
                    self.fileLoader = _loader
                }
                else {
                    if (json.buffers[bid].uri) {
                        self._bufferRequested++;
                        _loadArrayBuffer(self.baseUri + json.buffers[bid].uri, (resource)=>{
                            self._buffers[bid] = resource;
                            self._bufferLoaded++;
                            self._checkComplete();
                        });
                    }
                }
            }
        }
    });
};


glTFLoader.prototype._postprocess = function (callback) {

    
    curLoader = this;

    var i, leni, j, lenj;

    var scene, s;
    var node;
    var mesh, primitive, accessor;

    // load all materials
    if (this.glTF.materials) {
        for (i = 0, leni = this.glTF.materials.length; i < leni; i++) {
            this.glTF.materials[i] = new Material(this.glTF.json.materials[i]);
        }
    }

    // bufferviews
    if (this.glTF.bufferViews) {
        for (i = 0, leni = this.glTF.bufferViews.length; i < leni; i++) {
            this.glTF.bufferViews[i] = new BufferView(this.glTF.json.bufferViews[i], this._buffers[ this.glTF.json.bufferViews[i].buffer ]);
        }
    }

    function createMeshes(glTF, dracoLoader, cb) {
        let numToDecode = 0
        let numDecoded = 0
        for (let i = 0, leni = glTF.json.meshes.length; i < leni; i++) {
            let  m = glTF.json.meshes[i];
            for (let j = 0, len = m.primitives.length; j < len; ++j) {
                let p = m.primitives[ j ];
                //Draco
                if (p.extensions && p.extensions.KHR_draco_mesh_compression !== undefined) {
                    // for ( let attname in  p.extensions.KHR_draco_mesh_compression.attributes ) {
                    //     glTF.json.accessors[ p.attributes[attname] ].bufferView = p.extensions.KHR_draco_mesh_compression.bufferView;
                    //     // p.attributes[attname] = p.extensions.KHR_draco_mesh_compression.attributes[attname];
                    // }
                    // if (p.indices !== void 0) {
                    //     glTF.json.accessors[ p.indices ].bufferView = p.extensions.KHR_draco_mesh_compression.bufferView;
                    // }
                    let bufferViewIndex        = p.extensions.KHR_draco_mesh_compression.bufferView;
                    let gltfAttributeMap       = p.extensions.KHR_draco_mesh_compression.attributes;
                    let threeAttributeMap      = {};
                    let attributeNormalizedMap = {};
                    let attributeTypeMap = {};
                    for ( var attributeName in gltfAttributeMap ) {
                        var threeAttributeName = ATTRIBUTES[ attributeName ] || attributeName.toLowerCase();
                        threeAttributeMap[ threeAttributeName ] = gltfAttributeMap[ attributeName ];
                    }
                    for ( attributeName in p.attributes ) {
                        var threeAttributeName = ATTRIBUTES[ attributeName ] || attributeName.toLowerCase();
                        if ( gltfAttributeMap[ attributeName ] !== undefined ) {
                            var accessorDef = glTF.json.accessors[ p.attributes[ attributeName ] ];
                            var componentType = WEBGL_COMPONENT_TYPES[ accessorDef.componentType ];
                            attributeTypeMap[ threeAttributeName ] = componentType;
                            attributeNormalizedMap[ threeAttributeName ] = accessorDef.normalized === true;
                        }
                    }
                    var taskConfig = {
                        attributeIDs: threeAttributeMap,
                        attributeTypes: attributeTypeMap,
                        useUniqueIDs: !! threeAttributeMap
                    };

                    numToDecode++
                    dracoLoader.decodeGeometry( glTF.bufferViews[ bufferViewIndex ].data, taskConfig ).then((decodedGeometry)=>{
                        numDecoded++
                        m.primitives[j].indices = Uint16Array.from( decodedGeometry.index.array );
                        decodedGeometry.attributes.forEach(attribute => {
                            m.primitives[j].attributes[ attribute.name ] = attribute.array
                        });
                        if (numDecoded >= numToDecode) {
                            cb()
                        }
                    })
                }
            }
        }
        if (numToDecode==0) {
            cb()
        }

    }

    createMeshes(this.glTF, this.dracoLoader, ()=>{


        // accessors
        if (this.glTF.accessors) {
            for (i = 0, leni = this.glTF.accessors.length; i < leni; i++) {
                if (this.glTF.json.accessors[i].bufferView !== undefined ) {
                    this.glTF.accessors[i] = new Accessor(this.glTF.json.accessors[i], this.glTF.bufferViews[ this.glTF.json.accessors[i].bufferView ]);
                }
            }
        }

        // mesh
        for (i = 0, leni = this.glTF.meshes.length; i < leni; i++) {
            this.glTF.meshes[i] = new Mesh(this.glTF.json.meshes[i], i);
            this.glTF.meshes[i].id = 'MinimalGLTFMesh'
            this.glTF.meshes[i].name = 'MinimalGLTFMesh'
        }

        // node
        for (i = 0, leni = this.glTF.nodes.length; i < leni; i++) {
            this.glTF.nodes[i] = new Node(this.glTF.json.nodes[i], i);
        }

        // node: hook up children
        for (i = 0, leni = this.glTF.nodes.length; i < leni; i++) {
            node = this.glTF.nodes[i];
            for (j = 0, lenj = node.children.length; j < lenj; j++) {
                node.children[j] = this.glTF.nodes[ node.children[j] ];
            }
        }

        // scene Bounding box
        var nodeMatrix = new Array(this.glTF.nodes.length);
        for(i = 0, leni = nodeMatrix.length; i < leni; i++) {
            nodeMatrix[i] = mat4.create();
        }

        function execUpdateTransform(n, parent) {
            var tmpMat4 = nodeMatrix[n.nodeID];
            if (parent !== null) {
                mat4.mul(tmpMat4, nodeMatrix[parent.nodeID], n.matrix);
            } else {
                mat4.copy(tmpMat4, n.matrix);
            }
        }

        function execUpdateBBox(n, parent){
            var tmpMat4 = nodeMatrix[n.nodeID];
            var parentBVH;
            if (parent !== null) {
                parentBVH = parent.bvh;
            } else {
                parentBVH = scene.boundingBox;
            }
            if (n.mesh) {
                mesh = n.mesh;
                if (mesh.boundingBox) {
                    n.aabb = BoundingBox.getAABBFromOBB(mesh.boundingBox, tmpMat4);
                    if (n.children.length === 0) {
                        // n.bvh = n.aabb;
                        vec3.copy(n.bvh.min, n.aabb.min);
                        vec3.copy(n.bvh.max, n.aabb.max);
                    }
                }
            }
            vec3.min(parentBVH.min, parentBVH.min, n.bvh.min);
            vec3.max(parentBVH.max, parentBVH.max, n.bvh.max);
        }

        for (i = 0, leni = this.glTF.scenes.length; i < leni; i++) {
            scene = this.glTF.scenes[i] = new Scene(this.glTF, this.glTF.json.scenes[i]);
            scene.boundingBox = new BoundingBox();
            for (j = 0, lenj = scene.nodes.length; j < lenj; j++) {
                node = scene.nodes[j];
                node.traverseTwoExecFun(null, execUpdateTransform, execUpdateBBox);
            }
            scene.boundingBox.calculateTransform();
        }

        for (j = 0, lenj = this.glTF.nodes.length; j < lenj; j++) {
            node = this.glTF.nodes[j];
            if (node.bvh !== null) {
                node.bvh.calculateTransform();
            }
        }

        callback()

    })

};


const Type2NumOfComponent = {
    'SCALAR': 1,
    'VEC2': 2,
    'VEC3': 3,
    'VEC4': 4,
    'MAT2': 4,
    'MAT3': 9,
    'MAT4': 16
};

function _arrayBuffer2TypedArray(buffer, byteOffset, countOfComponentType, componentType) {
    switch(componentType) {
        case 5122: return new Int16Array(buffer, byteOffset, countOfComponentType);
        case 5123: return new Uint16Array(buffer, byteOffset, countOfComponentType);
        case 5124: return new Int32Array(buffer, byteOffset, countOfComponentType);
        case 5125: return new Uint32Array(buffer, byteOffset, countOfComponentType);
        case 5126: return new Float32Array(buffer, byteOffset, countOfComponentType);
        default: return null; 
    }
}

function _getAccessorData(accessor) {
    return _arrayBuffer2TypedArray(
        accessor.bufferView.data, 
        accessor.byteOffset, 
        accessor.count * Type2NumOfComponent[accessor.type],
        accessor.componentType
        );
}

// https://github.com/AnalyticalGraphicsInc/cesium/blob/master/Source/Core/getBaseUri.js
function _getBaseUri(uri) {
    var basePath = '';
    var i = uri.lastIndexOf('/');
    if(i !== -1) {
        basePath = uri.substring(0, i + 1);
    }
    return basePath;
}

function _loadJSON(src, callback) {
    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open('GET', src, true);
    xobj.onreadystatechange = function () {
        if (xobj.readyState == 4 && // Request finished, response ready
            xobj.status == "200") { // Status OK
            callback(xobj.responseText, this);
        }
    };
    xobj.send(null);
}

function _loadArrayBuffer(url, callback) {
    var xobj = new XMLHttpRequest();
    xobj.responseType = 'arraybuffer';
    xobj.open('GET', url, true);
    xobj.onreadystatechange = function () {
        if (xobj.readyState == 4 && xobj.status != "200") {
            console.warn('GET 404', url)
        }
        if (xobj.readyState == 4 && // Request finished, response ready
            xobj.status == "200") { // Status OK
            var arrayBuffer = xobj.response;
            if (arrayBuffer && callback) {
                callback(arrayBuffer);
            }
        }
    };
    xobj.send(null);
}

export default glTFLoader;